/** biome-ignore-all lint/correctness/useHookAtTopLevel: Pre-existing */
// biome-ignore lint/style/noRestrictedImports: RN Text delivers onPress inside nested Text where Tamagui text doesn't (see comment below)
import { Linking, Text as RNText } from "react-native";
import { type AnchorExtraProps, isWeb, type SizableTextProps } from "tamagui";
import { useLink } from "@medbillai/navigation/link";
import { previewUrl } from "@medbillai/utils";
import { openMailto } from "../utils/linking";
import { AnchorText } from "./Typography";
export type AnchorProps = SizableTextProps & AnchorExtraProps & {
  isPreviewLink?: boolean;
  title: string;
  href: string;
};
const isInternalLink = (href: string) => {
  return href.startsWith("/") || href.startsWith("#");
};
export const ExternalLink = AnchorText.styleable<AnchorProps>(({
  href,
  target,
  isPreviewLink,
  title,
  children,
  ...props
}) => {
  let linkProps = {};
  if (isWeb) {
    linkProps = {
      href,
      target
    };
  } else if (isPreviewLink) {
    linkProps = useLink({
      href: previewUrl({
        title,
        uri: href
      })
    });
  } else if (isInternalLink(href)) {
    linkProps = useLink({
      href
    });
  } else {
    const {
      onPress: consumerOnPress,
      ...textProps
    } = props;
    const onPress: typeof consumerOnPress = event => {
      consumerOnPress?.(event);
      if (href.startsWith("mailto:")) {
        void openMailto(href);
      } else {
        Linking.openURL(href).catch(error => {
          console.warn(`Failed to open URL: ${href}`, error);
        });
      }
    };
    // On native, a Tamagui-text onPress silently drops taps when this link
    // is nested inside another Text (the common inline-in-a-paragraph case).
    // The plain RN Text carries the press — it fires regardless of the
    // surrounding tree — while the AnchorText wrapper keeps the styling.
    return <AnchorText {...textProps}>
          <RNText onPress={onPress}>{children ?? title}</RNText>
        </AnchorText>;
  }
  return <AnchorText {...props} {...linkProps}>
        {children ?? title}
      </AnchorText>;
});